module.exports = __webpack_public_path__ + "img/player_turn_001.910f5587.png";